<template>
  <div>
    <div class="goods-head">
      <div class="slider-list">
        <div class="item selected">赞助记录</div>
      </div>
    </div>
    <!--表格-->
    <section class="main">
      <!--表格头部-->
      <article class="main-header">
        <ul>
          <li>公司名称</li>
          <!--<li>公司类型</li>-->
          <li>联系人</li>
          <li>联系电话</li>
          <!--<li>上次赞助</li>-->
          <li>本次赞助</li>
          <!--<li>支付方式</li>-->
          <li>赞助总额</li>
          <!--<li>审核人</li>-->
          <li>创建日期</li>
          <li>操作</li>
        </ul>
      </article>
      <!--表格内容-->
      <article class="main-body">
        <template v-if="detailsData.length < 1">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(item,itemIndex) in detailsData">
          <div :key="itemIndex" class="body-item">
            <ul>
              <li>{{ item.companyName }}</li>
              <!--<li>{{item.companyTypeLabel}}</li>-->
              <li>{{ item.companyContact }}</li>
              <li>{{ item.contactTel }}</li>
              <!--<li>{{item.oldMoney}}</li>-->
              <li>{{ item.newMoney }} <i v-if="item.newMoney==null">0</i>元</li>
              <!--<li>{{item.payType}}</li>-->
              <li>{{ item.moneyTotal }} <i v-if="item.moneyTotal==null">0</i>元</li>
              <!--<li>{{item.auditor}}</li>-->
              <li>{{ item.createDate }}</li>
              <li>
                <el-button plain size="small" @click="detailsClick(itemIndex)">
                  详情
                  <i :class="{'expand': detailsIndex == itemIndex}" class="el-icon-d-arrow-right" />
                </el-button>
              </li>
            </ul>
            <sponsorDetails v-if="detailsIndex == itemIndex" class="businessIf" :details="item" />
          </div>
        </template>
      </article>
      <!--分页-->
      <article class="main-pagination">
        <el-pagination
          :current-page="pagination.pageNo"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="changeCurrent"
          @size-change="changeSize"
        />
      </article>
    </section>
  </div>
</template>

<script type="text/ecmascript-6">
import { Page } from '@/utils/commonDataModel'
import { getList } from '@/api/personal/enterprise/sponsor/index.js'
import { staffAll } from '@/api/personal/enterprise'

import sponsorDetails from './components/sponsor-details.vue'
export default {
  components: {
    sponsorDetails
  },
  data() {
    return {
      // 表格数据
      // companyName: '', // 公司名称
      // companyTypeLabel: '', // 公司类型
      // companyContact: '', // 联系人
      // contactTel: '', // 联系电话
      // oldMoney: '', // 上次赞助
      // newMoney: '', // 本次赞助
      // payType: '', // 支付方式
      // moneyTotal: '', // 赞助总额
      // auditor: '', // 审核人
      // createDate: '' // 创建日期
      detailsData: [],
      // 表格分页
      pagination: new Page(),
      // 详情状态
      detailsIndex: -1
    }
  },
  mounted() {
    this.getSetList()
  },
  methods: {
    // 获取客户列表
    getSetList(data) {
      getList(data).then(res => {
        console.log('111111111111',res)
        this.pagination.total = res.result.total
        this.pagination.pageNo = res.result.pageNo
        this.pagination.pageSize = res.result.pageSize
        this.detailsData = res.result.rows
      })
    },
    // 详情按钮
    detailsClick(index) {
      if (this.detailsIndex == index) {
        this.detailsIndex = -1
      } else {
        this.detailsIndex = index
      }
    },
    // 分页-第几页
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.getSetList(this.pagination)
    },
    // 分页-每页多少条
    changeSize(size) {
      this.pagination.pageSize = size
      this.getSetList(this.pagination)
    }
  }
}
</script>
<style scoped lang='scss'>
  @import "./index.scss";
</style>
